import { Eye, Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { SupplierRow } from "../types/supplierListView.types";

interface SupplierRowActionsProps {
  row: SupplierRow;
  onView: (row: SupplierRow) => void;
  onEdit: (row: SupplierRow) => void;
  onDelete: (row: SupplierRow) => void;
}

const actionButtonClass = "tw-h-8 tw-w-8";

/** View / edit / delete icon actions for one grid row, styled after `ProductRowActions`. */
const SupplierRowActions = ({ row, onView, onEdit, onDelete }: SupplierRowActionsProps) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="View"
        onClick={() => onView(row)}
      >
        <Eye className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={actionButtonClass}
        title="Edit"
        onClick={() => onEdit(row)}
      >
        <Pencil className="tw-h-3.5 tw-w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={`${actionButtonClass} tw-text-destructive hover:tw-text-destructive`}
        title="Delete"
        onClick={() => onDelete(row)}
      >
        <Trash2 className="tw-h-3.5 tw-w-3.5" />
      </Button>
    </div>
  );
};

export default SupplierRowActions;
